import { PublisherInterface } from '@chili-publish/publisher-interface'
import { useIntl } from 'react-intl'

import CustomScrollbars from 'shared/ui/SimpleBar'

import {
  ChangeFrameProps,
  ChangeTextFormat,
  Font,
  Frame,
  TextFormat
} from '../../types'
import Title from '../PanelFirstLevelTitle'
import FrameControls from './components/FrameControls'

type PanelProps = {
  frame: Frame | null
  textFormat: TextFormat | null
  font: Font | null
  changeFrameProps: ChangeFrameProps
  changeTextFormat: ChangeTextFormat
  publisherConnector: PublisherInterface
  renderDefaultPanel: () => JSX.Element
}

const LeftPanel = ({
  frame,
  textFormat,
  font,
  changeFrameProps,
  changeTextFormat,
  publisherConnector,
  renderDefaultPanel,
}: PanelProps): JSX.Element => {
  const { formatMessage } = useIntl()

  return (
    <>
      <CustomScrollbars
        fixedHeader={
          <Title>
            {formatMessage({
              id: `Panel.title.${
                frame ? frame.type : 'startDesigning'
              }`
            })}
          </Title>
        }
      >
        {frame ? (
          <FrameControls
            frame={frame}
            textFormat={textFormat}
            font={font}
            changeFrameProps={changeFrameProps}
            changeTextFormat={changeTextFormat}
            publisherConnector={publisherConnector}
          />
        ) : (
          renderDefaultPanel()
        )}
      </CustomScrollbars>
    </>
  )
}

export default LeftPanel
